@file:Suppress("ktlint:standard:comment-wrapping")

package com.nonopn.skywatcher.common.login

import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.ProvidableCompositionLocal
import androidx.compose.runtime.compositionLocalOf
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.nonopn.skywatcher.common.ILoginCaller
import com.nonopn.skywatcher.common.login.pages.RouteMain
import com.nonopn.skywatcher.common.login.pages.RouterLogin
import com.nonopn.skywatcher.common.login.pages.RouterMain
import com.nonopn.skywatcher.common.login.pages.RouterRegister
import de.drick.compose.hotpreview.HotPreview
import eu.codlab.blipya.common_sub_login.generated.resources.Res
import eu.codlab.blipya.common_sub_login.generated.resources.app_sub_title
import eu.codlab.blipya.common_sub_login.generated.resources.login_account_title
import eu.codlab.compose.widgets.preview.PreviewDarkLightColumn
import eu.codlab.navigation.LocalNavigator
import eu.codlab.navigation.NavigatorLocalProvider
import eu.codlab.navigation.ScaffoldContentWrapper
import eu.codlab.viewmodel.rememberViewModel
import org.jetbrains.compose.resources.StringResource

val LocalOpenSessionModel = compositionLocalOf { OpenSessionModel.fake() }
val LocalLoginCaller: ProvidableCompositionLocal<ILoginCaller> =
    compositionLocalOf { error("no LocalLoginCaller available") }

val LocalLoginTitle: ProvidableCompositionLocal<StringResource> =
    compositionLocalOf { error("no LocalLoginTitle available") }
val LocalAppMainTitle: ProvidableCompositionLocal<StringResource> =
    compositionLocalOf { error("no LocalAppMainTitle available") }

@Composable
fun OpenSessionContent(
    appMainTitle: StringResource,
    loginTitle: StringResource,
    loginCaller: ILoginCaller,
) {
    val model = rememberViewModel { OpenSessionModel() }

    NavigatorLocalProvider(model) {
        model.navigator = LocalNavigator.current

        CompositionLocalProvider(
            LocalOpenSessionModel provides model,
            LocalAppMainTitle provides appMainTitle,
            LocalLoginCaller provides loginCaller,
            LocalLoginTitle provides loginTitle
        ) {
            ScaffoldContentWrapper(
                listOf(RouterMain, RouterLogin, RouterRegister),
                RouteMain,
                onMenuItemSelected = { _, _ -> /* nothing for the menu */ }
            )
        }
    }
}

@HotPreview(widthDp = 500, heightDp = 360, darkMode = true)
@HotPreview(widthDp = 500, heightDp = 360, darkMode = false)
@HotPreview(widthDp = 360, heightDp = 500, darkMode = true)
@HotPreview(widthDp = 360, heightDp = 500, darkMode = false)
@Composable
fun OpenSessionContentPreview() {
    PreviewDarkLightColumn(submodifier = { Modifier.height(200.dp) }) { modifier, _ ->
        OpenSessionContent(
            Res.string.app_sub_title,
            Res.string.login_account_title,
            object : ILoginCaller {
                override fun register(
                    email: String,
                    password: String,
                    callback: (err: Throwable?) -> Unit
                ) = Unit

                override fun login(
                    email: String,
                    password: String,
                    callback: (err: Throwable?) -> Unit
                ) = Unit
            }
        )
    }
}
